import { PackageType } from './Container';
import { AlertPackage } from './packages/alerts/AlertPackage';
import { AnnotationPackage } from './packages/annotations/AnnotationPackage';
import { TaskPackage } from './packages/assignment/TaskPackage';
import { AssistantPackage } from './packages/assistant/AssistantPackage';
import { AtlassianPackage } from './packages/atlassian/AtlassianPackage';
import { AuditingPackage } from './packages/auditing/AuditingPackage';
import { AutoLayoutPackage } from './packages/autoLayout/AutoLayoutPackage';
import { BoardSettingsPackage } from './packages/boardSettings/BoardSettingsPackage';
import { BuzzerPackage } from './packages/buzzer/BuzzerPackage';
import { CallPackage } from './packages/calls/CallPackage';
import { ConcealPackage } from './packages/conceal/ConcealPackage';
import { ConnectorPackage } from './packages/connector/ConnectorPackage';
import { ControlsPackage } from './packages/controls/ControlsPackage';
import { CounterPackage } from './packages/counter/CounterPackage';
import { ExportPackage } from './packages/dataExport/ExportPackage';
import { DevPackage } from './packages/dev/DevPackage';
import { FeaturePackage } from './packages/feature/FeaturePackage';
import { FramePackage } from './packages/frame/FramePackage';
import { GadgetPackage } from './packages/gadget/GadgetPackage';
import { GraphicPackage } from './packages/graphics/GraphicPackage';
import { HandPackage } from './packages/hand/HandPackage';
import { HandwritingPackage } from './packages/handwriting/HandwritingPackage';
import { HatsPackage } from './packages/hats/HatsPackage';
import { HaugPackage } from './packages/haug/HaugPackage';
import { HerdingPackage } from './packages/herding/HerdingPackage';
import { IncognitoPackage } from './packages/incognito/IncognitoPackage';
import { JukeboxPackage } from './packages/jukebox/JukeboxPackage';
import { LanguageModelImportPackage } from './packages/languageModelImport/LanguageModelImportPackage';
import { LayoutPackage } from './packages/layout/LayoutPackage';
import { LensPackage } from './packages/lens/LensPackage';
import { MarkerPackage } from './packages/marker/MarkerPackage';
import { ObjectLibraryPackage } from './packages/objectLibrary/ObjectLibraryPackage';
import { PaperPackage } from './packages/paper/PaperPackage';
import { PollingPackage } from './packages/polling/PollingPackage';
import { PresentationPackage } from './packages/presentation/PresentationPackage';
import { SymbolPackage } from './packages/props/SymbolPackage';
import { ReactionPackage } from './packages/reactions/ReactionPackage';
import { ReadyCheckPackage } from './packages/readyCheck/ReadyCheckPackage';
import { ShapePackage } from './packages/shapes/ShapePackage';
import { SpinnerPackage } from './packages/spinner/SpinnerPackage';
import { SpotlightPackage } from './packages/spotlight/SpotlightPackage';
import { StopwatchPackage } from './packages/stopwatch/StopwatchPackage';
import { TabularImportPackage } from './packages/tabularImport/TabularImportPackage';
import { TextPackage } from './packages/text/TextPackage';
import { ToastPackage } from './packages/toast/ToastPackage';
import { TokenPackage } from './packages/tokens/TokenPackage';
import { TopicPackage } from './packages/topics/TopicPackage';
import { TrayPackage } from './packages/tray/TrayPackage';
import { EmbedPackage } from './packages/video/EmbedPackage';
import { VoterPackage } from './packages/voter/VoterPackage';
import { VotingPackage } from './packages/voting/VotingPackage';
import { WaitingRoomPackage } from './packages/waitingRoom/WaitingRoomPackage';
import { ZonePackage } from './packages/zones/ZonePackage';

// Dependency expression required here, but for now manually ensure:
// - Incognito loads before Concealment

export const Packages: PackageType[] = [
    IncognitoPackage,
    // MorePackage,
    // PropPackage,
    AlertPackage,
    AnnotationPackage,
    AssistantPackage,
    AtlassianPackage,
    AuditingPackage,
    AutoLayoutPackage,
    BoardSettingsPackage,
    BuzzerPackage,
    CallPackage,
    ConcealPackage,
    ConnectorPackage,
    ControlsPackage,
    CounterPackage,
    DevPackage,
    EmbedPackage,
    ExportPackage,
    FeaturePackage,
    FramePackage,
    GadgetPackage,
    GraphicPackage,
    HandPackage,
    HandwritingPackage,
    HatsPackage,
    HaugPackage,
    HerdingPackage,
    JukeboxPackage,
    LanguageModelImportPackage,
    LayoutPackage,
    LensPackage,
    MarkerPackage,
    ObjectLibraryPackage,
    PaperPackage,
    PollingPackage,
    PresentationPackage,
    ReactionPackage,
    ReadyCheckPackage,
    ShapePackage,
    SpinnerPackage,
    SpotlightPackage,
    StopwatchPackage,
    SymbolPackage,
    TabularImportPackage,
    TaskPackage,
    TextPackage,
    ToastPackage,
    TokenPackage,
    TopicPackage,
    TrayPackage,
    VoterPackage,
    VotingPackage,
    WaitingRoomPackage,
    ZonePackage,
];
